<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-03-01 10:53:48
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\HolidayType\viewHolidayType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-12 11:53:08
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="
      iSEdited
        ? $t('label_essweb_holidayType_form_editTitle')
        : $t('label_essweb_holidayType_form_viewTitle')
    "
    delBtn
    :initData="HolidayTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['holiday_type_name', 'holiday_type_code', 'remarks']"
    pad="0"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_holidayType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <template v-slot:page-main>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation class="pa-8">
            <v-row>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="HolidayTypeData.holiday_type_name"
                  @change="
                    (valueArr) => {
                      HolidayTypeData.holiday_type_name = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_holidayType_list_HolidayTypeNameLabel')
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :label="
                    $t('label_essweb_holidayType_list_HolidayTypeCodeLabel')
                  "
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="HolidayTypeData.holiday_type_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_holidayType_list_HolidayTypeRemarksLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  maxlength="500"
                  single-line
                  dense
                  counter="500"
                  v-model="HolidayTypeData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col> </v-row></v-form
        ></template>
        <template v-slot:content-2>
          <v-card :elevation="0" class="pa-0">
            <v-card-text class="pa-0">
              <Tabler
                :headers="headers"
                :showNoContent="false"
                :items="desserts"
              >
                <template v-slot:item.holiday_name="{ item }">
                  {{ $getCommonLangValue(item.holiday_name) }}
                </template>
                <template v-slot:item.holiday_utc_date="{ item }">
                  {{ $getDateTime(item.holiday_utc_date, "YYYY/MM/DD") }}
                </template>
                <template v-slot:item.holiday_time_zone="{ item }">
                  {{ $getUtcByCode(item.holiday_time_zone) }}
                </template>
              </Tabler>
            </v-card-text>
            <v-card-actions class="pb-0 pl-0" v-if="iSEdited">
              <v-btn
                text
                color="primary"
                small
                class="text-capitalize mb-3"
                @click="toEditMapping"
              >
                {{ $t("label_essweb_holidayType_form_editHolidayBtnLabel") }}
                <span class="material-icons-round">add</span>
              </v-btn>
            </v-card-actions>
          </v-card></template
        >
      </Taber></template
    >
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <template v-slot:tools-main>
      <mapToPublicHoliday
        :show="mapToDiag"
        :PorpertyData="curPorperty"
        @editPorperty="onEditProperty"
        @close="mapToDiag = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import mapToPublicHoliday from "@/Page/EssAdmin/Holiday/HolidayType/components/mapToPublicHoliday";
import { mapGetters } from "vuex";
export default {
  name: "editHolidayType",
  components: { mapToPublicHoliday },
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      HolidayTypeData: {
        holiday_type_name: "",
        holiday_type_code: "",
        remarks: "",
      },
      iSEdited: false,
      curTab: "tab-1",
      isChanged: false,
      taber: [
        "label_essweb_holidayType_form_step_generalLabel",
        "label_essweb_holidayType_form_step_holidayListLabel",
      ],
      mapToDiag: false,
      curPorperty: null,
      desserts: [],
      curUuids: [],
      headers: [
        {
          text: "label_essweb_holidayGroup_form_holidayNameLabel",
          value: "holiday_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayDateLabel",
          value: "holiday_utc_date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayZoneLabel",
          value: "holiday_time_zone",
          align: "start",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    desserts(val) {
      const that = this;
      that.curUuids = [];
      this.curPorperty = val;
      val.forEach(function (item) {
        that.curUuids.push(item.uuid);
      });
    },
  },
  mounted() {
    this.getDetail();
    this.getPorpertyList();
  },
  methods: {
    toDelete: function () {
      const that = this;

      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/delete-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_holidayType_list_deleteHolidayTypeSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["holiday_type_name_save"] = res.data.holiday_type_name;
        res.data.holiday_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.holiday_type_name
        );
        that.HolidayTypeData = res.data;
      });
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-map-type-and-day/get-list/",
        data: {
          holiday_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts = res.data;
      });
    },
    toEditMapping: function () {
      const that = this;
      this.curPorperty = [];
      this.$Sleep(300).then(() => {
        that.curPorperty = that.desserts;
      });
      this.mapToDiag = true;
    },
    onEditProperty: function (obj) {
      this.mapToDiag = false;
      const that = this;
      var newUuids = [];
      obj.forEach(function (item) {
        newUuids.push(item.uuid);
      });

      this.toEditHoliday(newUuids);
    },
    toEditHoliday: function (uuids) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-map-type-and-day/update-table/",
        data: {
          holiday_type_uuid: this.$route.params.id,
          latest_ids: uuids.join(","),
        },
      }).then((res) => {
        that.getPorpertyList();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/update-table/",
        data: {
          uuid: this.$route.params.id,
          holiday_type_name: this.$transCommonLangKey(
            this.HolidayTypeData.holiday_type_name,
            this.HolidayTypeData.holiday_type_name_save
          ),
          holiday_type_code: this.HolidayTypeData.holiday_type_code,
          remarks: this.HolidayTypeData.remarks,
        },
      }).then((res) => {
        that.toBack();
        that.$showMessage({
          text: that.$t(
            "label_essweb_holidayType_list_updatePublicHolidayTypeSuccessLabel"
          ),
          type: "success",
        });
      });
    },
  },
};
</script>